import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
export function track(event, data) {
  if (data === void 0) {
    data = {};
  }
  try {
    const language = app.data.btLanguage || document.documentElement.lang.split('-')[0];
    Promise.resolve(window.umami?.track(event, {
      language,
      ...data
    })).catch(() => {});
  } catch {
    // Analytics must never interrupt forum actions.
  }
}
function trackLink(event) {
  if (event.defaultPrevented || event.type === 'auxclick' && event.button !== 1) return;
  const link = event.target?.closest?.('.Post-body a[href]');
  if (!link || link.closest('.Post-preview')) return;
  let url;
  try {
    url = new URL(link.href, location.href);
  } catch {
    return;
  }
  if (!['http:', 'https:'].includes(url.protocol)) return;
  let kind;
  if (link.hasAttribute('download') || /\.(apk|hap|zip|7z|tar|gz|exe|dmg)$/i.test(url.pathname)) kind = 'file';else if (url.hostname === 'github.com' && /^\/[^/]+\/[^/]+\/releases\/(?:tag|download)\//.test(url.pathname)) kind = 'release';else if (['pan.quark.cn', 'pan.baidu.com'].includes(url.hostname)) kind = 'cloud_share';
  if (!kind && url.origin === location.origin) return;
  const discussion = app.current.get('discussion');
  track(kind === 'file' ? 'download_click' : 'outbound_link_click', {
    target_host: url.hostname,
    link_kind: kind || 'reference',
    ...(discussion ? {
      discussion_id: discussion.id()
    } : {})
  });
}
app.initializers.add('bydtalk-analytics', () => {
  extend('flarum/forum/components/SignUpModal', 'oninit', function () {
    track('signup_open', {
      method: this.attrs.token ? 'oauth' : 'password'
    });
  });
  for (const [composer, event] of [['DiscussionComposer', 'discussion_open'], ['ReplyComposer', 'reply_open']]) {
    extend('flarum/forum/components/' + composer, 'oninit', function () {
      track(event, this.attrs.discussion ? {
        discussion_id: this.attrs.discussion.id()
      } : {});
    });
  }

  // Observe successful native requests without replacing form or model behavior.
  override(app, 'request', function (original, options) {
    if (options.method?.toUpperCase() !== 'POST') return original(options);
    const base = app.forum.attribute('baseUrl');
    const api = app.forum.attribute('apiUrl');
    let event,
      data = {};
    if (options.url === base + '/register') {
      event = 'signup_success';
      data.method = options.body?.token ? 'oauth' : 'password';
      track('signup_submit', data);
    } else if (options.url === base + '/login') {
      event = 'login_success';
      data.method = 'password';
    } else if (options.url === api + '/discussions') event = 'discussion_create_success';else if (options.url === api + '/posts') event = 'reply_create_success';else if (options.url === api + '/bydtalk/vehicles') event = 'vehicle_save_success';
    if (!event) return original(options);
    return original(options).then(response => {
      const resource = response?.data;
      if (event === 'signup_success' && (resource?.type !== 'users' || !resource.id)) return response;
      if (event === 'login_success' && !response?.userId) return response;
      if (event === 'vehicle_save_success' && response?.saved !== true) return response;
      if (event === 'discussion_create_success') {
        if (resource?.type !== 'discussions' || !resource.id) return response;
        data.discussion_id = resource.id;
      }
      if (event === 'reply_create_success') {
        if (resource?.type !== 'posts' || !resource.id) return response;
        const id = resource.relationships?.discussion?.data?.id;
        if (id) data.discussion_id = id;
      }
      track(event, data);
      return response;
    });
  });
  document.addEventListener('click', trackLink);
  document.addEventListener('auxclick', trackLink);
});
flarum.reg.add('bydtalk-community', 'analytics', { track: track, });